import { Brokerage } from "./Brokerage";
import { Build } from "./Build";
import { CST } from "./CST";
import { Extra } from "./Extra";
import { Personal } from "./Personal"; // Import the new Personal component
import { Result } from "./Result";
import { Terrain } from "./Terrain";
import { VGV } from "./VGV";

// Types
import type { IBrokerageProps } from "./Brokerage/types";
import type { IBuildProps } from "./Build/types";
import type { ICSTProps } from "./CST/types";
import type { IExtraProps } from "./Extra/types";
import type { IPersonalProps } from "./Personal/types"; // Import the new Personal types
import type { IResultProps } from "./Result/types";
import type { ITerrainProps } from "./Terrain/types";
import type { IVGVProps } from "./VGV/types";

export const Partials = {
	Terrain: (args: ITerrainProps) => <Terrain {...args} />,
	Build: (args: IBuildProps) => <Build {...args} />,
	VGV: (args: IVGVProps) => <VGV {...args} />,
	Brokerage: (args: IBrokerageProps) => <Brokerage {...args} />,
	CST: (args: ICSTProps) => <CST {...args} />,
	Extra: (args: IExtraProps) => <Extra {...args} />,
	Personal: (args: IPersonalProps) => <Personal {...args} />, // Add the new Personal component
	Result: (args: IResultProps) => <Result {...args} />, // Add the new Personal component
};
